import { IAnswer, IQuestion } from './question';
import { IReservationResponse } from './reservation';

export interface IPaymentReservation {
    CalendarId?: number;
    ServiceId: number;
    ScheduleId?: number,
    ClientKey?: string;
    PersonCount: number;
    StartTime: string;
    ArriveTime?: string;
    Questions?: IQuestion[] | IAnswer[];
}

export interface IPaymentReservationDetails extends IPaymentReservation {
    Id: number;
    PaymentUser?: IPaymentUserDetails;
    EndTime: string;
}

export interface IPaymentUser {
    Name: string;
    Email: string;
    Phone: string;
    InvoiceName?: string;
    Country?: string;
    City?: string;
    StreetAddress?: string;
    PostalCode?: string;
    PrivatePerson?: boolean;
    TaxNumber?: string;
    PocketId: number;
}

export interface IPaymentUserDetails extends IPaymentUser {
    Id: number;
}

export interface IPaymentReservationRequest {
    User: IPaymentUser;
    Reservations: IPaymentReservation[];
    TermsAccepted: boolean;
}

export enum TransactionStatus {
    Success = 1,
    Failed = 2,
    Pending = 3
}

export interface IPaymentResultResponse {
    TransactionStatus: TransactionStatus;
    OnlinePaymentKey: string;
    PaidReservations: IReservationResponse[];
    UnPaidReservations: IPaymentReservationDetails[];
    FailedPaidReservations: IPaymentReservationDetails[];
}

export interface IPaymentReservationResponse {
    PaymentUrl: string;
    HasCollision: boolean;
    HasPaymentError: boolean;
}

export const isPaymentReservationResponse = (variableToCheck: any): variableToCheck is IPaymentReservationResponse => {
    return variableToCheck.PaymentUrl !== undefined;
}